import { create } from "zustand";
import { immer } from "zustand/middleware/immer";
import { devtools } from "zustand/middleware";

export const botControlInitialState = {
  messages: [],
  stepToBack: -1,
  currentStep: -1,
  showPaymentModal: false,
  isBotLoading: false,
  couponErrorMessages: [],
  lastRenderedStep: { name: "", botMessage: "", botOptions: [] },
  skipStepTracking: false,
  skipStepAction: false,
  resumePlansTargetStep: null,
  pendingMessageBlock: [],
};

export const useBotControlStore = create()(
  devtools(
    immer((set) => ({
      ...botControlInitialState,
      setMessages: (message) => {
        set(
          (state) => {
            state.messages = [...state.messages, message];
          },
          true,
          "setMessages"
        );
      },
      setCurrentStep: (step) => {
        set(
          (state) => {
            state.currentStep = step;
          },
          true,
          "setCurrentStep"
        );
      },
      setShowPaymentModal: (show) => {
        set(
          (state) => {
            state.showPaymentModal = show;
          },
          true,
          "setShowPaymentModal"
        );
      },
      appendPendingMessageBlock: (entry) => {
        set(
          (state) => {
            state.pendingMessageBlock.push(entry);
          },
          true,
          "appendPendingMessageBlock"
        );
      },
      clearPendingMessageBlock: () => {
        set(
          (state) => {
            state.pendingMessageBlock = [];
          },
          true,
          "clearPendingMessageBlock"
        );
      },
    })),
    { enabled: true, name: "useBotControlStore" }
  )
);

export default useBotControlStore;
